// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
import { FIELD_TYPES } from "../../../../../../constants/template-field-type";
export default {
    crmCardButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Crm Card Button Text",
        translatable: true
    },
    crmCardParagraph: {
        type: FIELD_TYPES.TEXT,
        label: "Crm Card Paragraph",
        translatable: true
    },
    crmCardTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Crm Card Title",
        translatable: true
    },
    devCardButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Dev Card Button Text",
        translatable: true
    },
    devCardParagraph: {
        type: FIELD_TYPES.TEXT,
        label: "Dev Card Paragraph",
        translatable: true
    },
    devCardTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Dev Card Title",
        translatable: true
    },
    headingBlack: {
        type: FIELD_TYPES.TEXT,
        label: "Heading Black",
        translatable: true
    },
    headingGradient: {
        type: FIELD_TYPES.TEXT,
        label: "Heading Gradient",
        translatable: true
    },
    sectionSmallTagline: {
        type: FIELD_TYPES.TEXT,
        label: "Section Small Tagline",
        translatable: true
    },
    sectionSubtitle: {
        type: FIELD_TYPES.TEXT,
        label: "Section Subtitle",
        translatable: true
    },
    serviceCardButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Service Card Button Text",
        translatable: true
    },
    serviceCardParagraph: {
        type: FIELD_TYPES.TEXT,
        label: "Service Card Paragraph",
        translatable: true
    },
    serviceCardTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Service Card Title",
        translatable: true
    },
    wmCardButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Wm Card Button Text",
        translatable: true
    },
    wmCardParagraph: {
        type: FIELD_TYPES.TEXT,
        label: "Wm Card Paragraph",
        translatable: true
    },
    wmCardTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Wm Card Title",
        translatable: true
    },
    crmCardImageUrl: {
        type: FIELD_TYPES.NESTED,
        label: "Crm Card Image URL",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    devCardImageUrl: {
        type: FIELD_TYPES.NESTED,
        label: "Dev Card Image URL",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    serviceCardImageUrl: {
        type: FIELD_TYPES.NESTED,
        label: "Service Card Image URL",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    wmCardImageUrl: {
        type: FIELD_TYPES.NESTED,
        label: "Wm Card Image URL",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    hideComponent: {
        type: FIELD_TYPES.BOOLEAN,
        label: "Hide Component",
        translatable: false
    }
};
